import angular from 'angular';

class DebounceService {

  constructor($q, $timeout) {
    "ngInject";

    this.$q = $q;
    this.$timeout = $timeout;
  }

  debounce(func, wait, immediate) {
    let deferred = this.$q.defer();
    let self = this;

    return function () {
      const context = this;
      const args = arguments;

      let later = function () {
        self.timeout = null;
        if (!immediate) {
          deferred.resolve(func.apply(context, args));
          deferred = self.$q.defer();
        }
      };

      let callNow = immediate && !self.timeout;
      if (self.timeout) {
        self.$timeout.cancel(self.timeout);
      }

      self.timeout = self.$timeout(later, wait);

      if (callNow) {
        deferred.resolve(func.apply(context, args));
        deferred = self.$q.defer();
      }

      return deferred.promise;
    };
  };
}

export default angular.module('services.debounce', [])
  .service('debounceService', DebounceService)
  .name;